import React from "react";
import Loader from "../Loader/Loader";

interface ILoaderWrapper {
  children: JSX.Element | JSX.Element[];
  loader: boolean;
}

const LoaderWrapper = (props: ILoaderWrapper) => {
  const { children, loader } = props;
  return (
    <React.Fragment>
      {loader ? (
        <div className="row m-3 d-flex justify-content-center">
          <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3  d-flex justify-content-center">
            <Loader />
          </div>
        </div>
      ) : (
        children
      )}
    </React.Fragment>
  );
};

export default LoaderWrapper;
